export var CompanyRegion;
(function (CompanyRegion) {
    CompanyRegion[CompanyRegion["Unknown"] = 0] = "Unknown";
    CompanyRegion[CompanyRegion["West"] = 1] = "West";
    CompanyRegion[CompanyRegion["South"] = 2] = "South";
    CompanyRegion[CompanyRegion["North"] = 3] = "North";
    CompanyRegion[CompanyRegion["East"] = 4] = "East";
    CompanyRegion[CompanyRegion["Implementatie"] = 5] = "Implementatie";
    CompanyRegion[CompanyRegion["Duitsland"] = 6] = "Duitsland";
    CompanyRegion[CompanyRegion["Noordoost"] = 7] = "Noordoost";
    CompanyRegion[CompanyRegion["Zuid"] = 8] = "Zuid";
    CompanyRegion[CompanyRegion["Nederland"] = 9] = "Nederland";
    CompanyRegion[CompanyRegion["ImplementatieBuiltech"] = 10] = "ImplementatieBuiltech";
})(CompanyRegion || (CompanyRegion = {}));
